module.exports = __webpack_public_path__ + "f02e34e72c3ddeb7f8c8cd8963b2e0fe.png";